<mat-dialog-content [formGroup]="form">
  <p>{{ content }}</p>

  <label for="commentaire">
    {{ data.justificationLabel ?? 'front.modaleCommentaire.commentaire.label' | translate}}
    @if (data.commentaireRequired) {
      <span class="star">*</span>
      } :
    </label>
    <textarea name="commentaire" formControlName="commentaire" class="form-control" id="commentaire" rows="{{cols}}">
      {{ data.commentaire }}
    </textarea>
    @if (data.maxLength) {
      <small class="float-right" [style]="{'color' : commentaire.length > data.maxLength ? 'red' : 'black'}">
        {{ commentaire.length + ' / ' + data.maxLength }}
      </small>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">{{ cancel }}</button>
    <button [disabled]="!form.valid" mat-raised-button [mat-dialog-close]="{ 'commentaire' : commentaire}" color="primary" >{{ confirm }}</button>
  </mat-dialog-actions>
